/**
 * @module IAlerta
 * @description Componente reutilizable de alerta para mostrar mensajes de error/advertencia.
 * Se utiliza en el flujo de pagos para notificar:
 * - Documento inexistente o erróneo
 * - Valores de abono fuera del rango permitido
 * - Errores de validación del formulario
 *
 * Soporta diferentes estilos de alerta mediante la prop "tipo" (clases de Bootstrap).
 * Incluye un botón de cierre (actualmente oculto con d-none).
 */

import {FC} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

/** Props para el componente IAlerta */
type props2 = {
  /** Texto del mensaje de error/advertencia a mostrar */
  mensaje: string
  /** Clase CSS de Bootstrap para el estilo del alert (ej: 'bg-danger', 'bg-warning') */
  tipo: string
}

/**
 * IAlerta - Componente de alerta con ícono de exclamación y mensaje de error.
 * Renderiza un alert de Bootstrap con texto claro sobre fondo coloreado.
 * @param mensaje - Texto descriptivo del error
 * @param tipo - Clase CSS de fondo (determina el color del alert)
 */
const IAlerta: FC<props2> = ({mensaje, tipo}) => {
  return (
    <div className='row mt-4'>
      <div className={clsx('alert alert-dismissible d-flex flex-column flex-sm-row p-5 ', tipo)}>
        <span className='svg-icon svg-icon-2hx svg-icon-light mt-1'>
          <FontAwesomeIcon icon={'exclamation'} />
        </span>
        <div className='d-flex flex-column text-light pe-0 pe-sm-10'>
          <h5 className='mb-1 text-white'>Error</h5>
          <span>{mensaje}</span>
        </div>

        <button
          type='button'
          className='position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto d-none'
          data-bs-dismiss='alert'
        >
          <span className='svg-icon svg-icon-2x svg-icon-light'>
            <FontAwesomeIcon icon={'times'} />
          </span>
        </button>
      </div>
    </div>
  )
}

export {IAlerta}
